import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button } from "../../common/Button";
import SelectFiled from "../../common/textfield/SelectFiled";
import SearchSelect from "../../common/textfield/SearchSelect";
import TextInput from "../../common/textfield/TextInput";
import TextArea from "../../common/textfield/TextArea";
import { addRow, answerTypeOptions, handleFormChange, iconStyle, removeRow, comTypeOptions } from "./Constant";
import { Add, Remove } from "@mui/icons-material";
import { questionnaireForOptions, questionTagFreeTextOptions, questionTagRadioOptionsVideoVisit, questionTagRadioOptions, questionTagDropDownOptions, questionTagFreeTextOptionsGetCare, questionTagRadioOptionsGetCare, questionTagDropDownOptionsGetCare } from "./Constant";
import { useConfirmDialog } from "../../../hooks/useConfirmDialog";
import { useSelector } from "react-redux";
import { deleteQuestion } from "../../api/Questionnaire";
import { failed, success } from "../../common/Toastify";
import DeleteIcon from "../../../assets/images/Tag.svg";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import { ViewDate } from "../../../utils/DateSupport";
import { useOrgQuery } from "../../../hooks/ReactQueryHooks/useOrgQuery";
import { useQuestionCategoryQuery } from "../../../hooks/ReactQueryHooks/useQuestionCategoryQuery";

export function QuestionForm({
  btnLoading,
  formik,
  handleShow,
  isCreate,
  handleQuestionTagValue,
  isReadOnly,
  refreshTable,
  modalShow,
  onIsModalTagChange,
  enableOrgChange,
}) {
  const [selectedCategoryType, setSelectedCategoryType] = useState();
  const [questionInput, setQuestionInput] = useState(formik.values.question || "");
  const [deleting, setDeleting] = useState(false);
  const userType = useSelector((state) => state?.auth?.user?.["cognito:groups"]);
  const userOrg = useSelector((state) => state?.auth?.user?.["custom:orgId"]);
  const { getConfirmation } = useConfirmDialog();
  const [anchorEl, setAnchorEl] = useState(null);
  const [stackName, setStackName] = useState();
  const [questionTagValue, setQuestionTagValue] = useState(formik.values.tag);
  const [isVideoVisit, setIsVideoVisit] = useState(false);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const [isModalTag, setIsModalTag] = useState(false);

  // --- ORG DROPDOWN (first field) ---
  const [orgOptions, setOrgOptions] = useState([]);
  const selectedOrgId = formik.values.orgId || userOrg || "";
  const TAG_LABELS = {
    TELEPHONE: "Return Telephone Number",
    CHANNEL: "Preferred Channel",
    REASON: "Reason for visit",
    LOCATION: "Patient Location",
    RELATIONSHIP: "Relationship to patient",
    SELFCALLING: "Calling for yourself",
    CONSENT: "Patient Consent",
    CALLER: "Caller Name",
    INCLINATION: "Patient Inclination",
    COMPLIANCE: "Patient Compliance",
  };

  useOrgQuery({
    onSuccess: (data) => {
      const opts = (data || []).map((o) => ({ value: o?.id, name: o?.name }));
      setOrgOptions(opts);
      if (!formik.values.orgId && opts.length) {
        // initialize formik org if missing
        formik.setFieldValue("orgId", userOrg || opts[0].value);
      }
    },
    refetchOnWindowFocus: false,
  });

  const handleOrgChange = (selected) => {
    const newOrgId = selected?.value || "";
    formik.setFieldValue("orgId", newOrgId);
    // RESET dependent fields
    formik.setFieldValue("category", "");
    setSelectedCategoryType(undefined);
    setIsVideoVisit(false);
    setQuestionTagValue(undefined);
    setStackName(undefined);
    formik.setFieldValue("tag", "");
  };

  // --- CATEGORIES FOR SELECTED ORG ---
  const [categories, setCategories] = useState([]);
  useQuestionCategoryQuery({
    orgId: selectedOrgId,
    onSuccess: (data) => setCategories(data || []),
  });

  // when categories load (or re-load after org change), normalize edit state
  useEffect(() => {
    if (!isCreate && formik.values.category && categories.length) {
      const hasPercent = String(formik.values.category).includes("%");
      const found = categories.find((c) =>
        hasPercent ? `${c.categoryName}%${c.id}` === formik.values.category : c.id === formik.values.category
      );
      if (found) {
        formik.setFieldValue("category", `${found.categoryName}%${found.id}`);
        setSelectedCategoryType(found.categoryType);
        setIsVideoVisit(found.categoryType === "clinical-visit");
      }
    }
    // For create mode or when org changes we already reset category above.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categories]);

  useEffect(() => {
    const t = formik?.values?.tag;
    if (t) {
      setQuestionTagValue(t);
      setStackName(TAG_LABELS[t] ?? "");
    } else {
      setQuestionTagValue(undefined);
      setStackName(undefined);
    }
  }, [formik?.values?.tag]);

  const getCategoryTypeName = (categoryType) => {
    const category = questionnaireForOptions.find((option) => option.value === categoryType);
    return category ? category.name : categoryType;
  };

  // Handle the change in the Category and update selectedCategoryType
  const handleCategoryChange11 = (event) => {
    setQuestionInput("");
    setQuestionTagValue(undefined);
    formik.setFieldValue("tag", "");
    formik.handleChange(event);

    const selectedValue = event.target.value; // "name%id"
    const picked = categories.find((option) => `${option.categoryName}%${option.id}` === selectedValue);
    const ctype = picked ? picked.categoryType : "";
    setSelectedCategoryType(ctype);
    setIsVideoVisit(ctype === "clinical-visit");
  };

  const handleQuestionInputChange = (event) => {
    setQuestionInput(event.target.value);
    formik.handleChange(event);
  };

  const hasAccess = userType?.includes("Super-Admin") ? true : null;

  const handleDelete = async (id, entryName) => {
    const confirmed = await getConfirmation({
      title: "Attention!",
      entryName,
      actionBtnTitle: "Deactivate",
      message: "Are you sure you would like to deactivate ",
    });
    if (confirmed) {
      setDeleting(formik?.values?.id);
      deleteQuestion(formik?.values?.id)
        .then(() => {
          refreshTable?.();
          handleShow?.();
          success("Question Deactivated!");
        })
        .catch((res) => failed(res?.response?.data?.message || res?.response?.data?.error || res.message))
        .finally(() => setDeleting(false));
    }
  };

  const handleClick = (event) => setAnchorEl(anchorEl ? null : event.currentTarget);

  const handleClose = (selectedValue) => {
    setIsModalTag(false);
    setAnchorEl(null);
    if (typeof selectedValue === "object") return;

    if (selectedValue !== undefined) {
      setQuestionTagValue(selectedValue);
      formik.setFieldValue("tag", selectedValue);
      if (typeof handleQuestionTagValue === "function") handleQuestionTagValue(selectedValue);
      setStackName(TAG_LABELS[selectedValue] ?? "");
    }
  };

  const handleDeleteChip = () => {
    setQuestionTagValue(undefined);
    setStackName(undefined);
    setIsModalTag(true);
    if (typeof onIsModalTagChange === "function") onIsModalTagChange(true);
    formik.setFieldValue("tag", "");
    if (typeof handleQuestionTagValue === "function") handleQuestionTagValue("");
  };

  const handleChangeAnsType = () => {
    formik.setFieldValue("options", [{ id: Date.now(), text: "" }]);
    setQuestionTagValue(undefined);
    formik.setFieldValue("tag", "");
  };

  const categorySelectOptions = (categories || []).map((option) => ({
    value: `${option.categoryName}%${option.id}`,
    name: `${option.categoryName} ( ${getCategoryTypeName(option?.categoryType)} )`,
  }));

  const channelDataMap = [
    { id: Date.now(), text: "Video" },
    { id: Date.now() + 1, text: "Phone" },
  ];

  return (
    <form className="common-form border-fields" onSubmit={formik.handleSubmit} onChange={(e) => handleFormChange({ e, formik })}>
      {/* ORG SELECT — FIRST FIELD */}
      <Row>
        <Col md={5}>
          <SearchSelect
            keyField={"orgId"}
            label={"Organization"}
            formik={formik}
            placeholder={"Select"}
            options={orgOptions.map((o) => ({ label: o.name, value: o.value }))}
            value={orgOptions.map((o) => ({ label: o.name, value: o.value })).find((o) => o.value === selectedOrgId) || null}
            onChange={handleOrgChange}
            isDisabled={!enableOrgChange}
            required={true}
            isClearable={false}
          />
        </Col>
      </Row>

      {/* CATEGORY + QUESTION */}
      <Row>
        <Col md={5}>
          <SelectFiled
            keyField={"category"}
            label={"Category"}
            formik={formik}
            placeholder={"Select"}
            options={categorySelectOptions}
            onChange={handleCategoryChange11}
            disabled={isReadOnly || !selectedOrgId}
          />
        </Col>
        <Col md={7}>
          <TextInput
            keyField={"question"}
            label={"Enter Question"}
            formik={formik}
            placeholder={"Whats your question?"}
            value={questionInput}
            disabled={isReadOnly}
            onChange={handleQuestionInputChange}
          />
        </Col>
      </Row>


      {/* DYNAMIC FIELDS */}
      {(selectedCategoryType !== undefined &&
        (selectedCategoryType === "getcare-waitingroom" ||
          selectedCategoryType === "telephone-intake")) ? (
        <>
          <Row>
            <Col>
              <div className="field-wrap" style={{ margin: 0 }}>
                <label className="custom-checkbox" style={{ margin: 0, width: "fit-content" }}>
                  Is Mandatory
                  {!isVideoVisit &&
                    (questionTagValue === "CHANNEL" ||
                      questionTagValue === "TELEPHONE" ||
                      questionTagValue === "REASON" ||
                      questionTagValue === "CALLER" ||
                      questionTagValue === "LOCATION" ||
                      questionTagValue === "RELATIONSHIP" ||
                      questionTagValue === "SELFCALLING" ||
                      questionTagValue === "CONSENT" ||
                      questionTagValue === "INCLINATION" || 
                      questionTagValue === "COMPLIANCE") ? (
                    <>
                      <input style={{ width: "auto" }} type="checkbox" checked={true} onChange={() => formik.setFieldValue("required", !!!formik?.values?.required)} disabled={isReadOnly} />
                      <span className="checkmark"></span>
                    </>
                  ) : (
                    <>
                      <input style={{ width: "auto" }} type="checkbox" checked={formik.values.required} onChange={() => formik.setFieldValue("required", !!!formik?.values?.required)} disabled={isReadOnly} />
                      <span className="checkmark"></span>
                    </>
                  )}
                </label>
              </div>
            </Col>
          </Row>

          <Row className="align-items-center">
            <Col className="col-md-4">
              <SelectFiled
                keyField={"answerType"}
                label={"Answer type"}
                formik={formik}
                placeholder={"Answer type"}
                options={answerTypeOptions}
                disabled={isReadOnly}
                onChange={(e) => {
                  formik.handleChange(e);
                  handleChangeAnsType();
                }}
              />
            </Col>
            <Col>
              {!isVideoVisit && formik.values.answerType !== "checkbox" ? (
                <>
                  <img src={DeleteIcon} alt="Delete" onClick={(ev) => setAnchorEl(open ? null : ev.currentTarget)} style={{ cursor: "pointer" }} />
                  {!isReadOnly && (
                    <Menu
                      id="question-tag-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      anchorOrigin={{ vertical: "top", horizontal: "left" }}
                      transformOrigin={{ vertical: "top", horizontal: "left" }}
                    >
                      {selectedCategoryType === "telephone-intake" && (formik.values.answerType === "freeText" || formik.values.answerType === "singleFreeText")
                        ? questionTagFreeTextOptions.map((o) => <MenuItem key={o.value} onClick={() => handleClose(o.value)}>{o.name}</MenuItem>)
                        : selectedCategoryType === "telephone-intake" && formik.values.answerType === "radio"
                          ? questionTagRadioOptions.map((o) => <MenuItem key={o.value} onClick={() => handleClose(o.value)}>{o.name}</MenuItem>)
                          : selectedCategoryType === "telephone-intake" && formik.values.answerType === "dropDown"
                            ? questionTagDropDownOptions.map((o) => <MenuItem key={o.value} onClick={() => handleClose(o.value)}>{o.name}</MenuItem>)
                            : selectedCategoryType === "getcare-waitingroom" && (formik.values.answerType === "freeText" || formik.values.answerType === "singleFreeText")
                              ? questionTagFreeTextOptionsGetCare.map((o) => <MenuItem key={o.value} onClick={() => handleClose(o.value)}>{o.name}</MenuItem>)
                              : selectedCategoryType === "getcare-waitingroom" && formik.values.answerType === "radio"
                                ? questionTagRadioOptionsGetCare.map((o) => <MenuItem key={o.value} onClick={() => handleClose(o.value)}>{o.name}</MenuItem>)
                                : selectedCategoryType === "getcare-waitingroom" && formik.values.answerType === "dropDown"
                                  ? questionTagDropDownOptionsGetCare.map((o) => <MenuItem key={o.value} onClick={() => handleClose(o.value)}>{o.name}</MenuItem>)
                                  : null}
                    </Menu>
                  )}
                </>
              ) : null}

              {(formik.values.answerType === "freeText" || formik.values.answerType === "singleFreeText" || formik.values.answerType === "radio" || formik.values.answerType === "dropDown") &&
                questionTagValue !== undefined &&
                stackName !== undefined ? (
                <Stack direction="row" spacing={1} className="d-inline-flex ms-1 ms-sm-4">
                  <Chip label={stackName} onDelete={handleDeleteChip} color={isReadOnly ? "default" : "primary"} disabled={isReadOnly} />
                </Stack>
              ) : null}
            </Col>
            <Col className="d-none" />
          </Row>

          <Row>
            {(formik.values.answerType === "freeText" || formik.values.answerType === "singleFreeText") ? null : (questionTagValue === "CHANNEL" && formik.values.answerType === "radio" &&
              selectedCategoryType === "getcare-waitingroom") ? (
              <Col>
                {channelDataMap?.map((row, index) => (
                  <div key={row.id}>
                    <Row className="mt-2">
                      <Col style={{ marginBottom: "-1.5rem" }}>
                        {index === 0 ? (
                          <SelectFiled
                            keyField={`options[0].text`}
                            formik={formik}
                            placeholder={"Chat/Phone"}
                            isError={formik?.touched?.options?.[index]?.text && formik?.errors?.options?.[index]?.text}
                            options={comTypeOptions}
                            disabled={isReadOnly}
                            onChange={(e) => formik.handleChange(e)}
                          />
                        ) : null}
                      </Col>
                      <Col />
                      <Col />
                    </Row>

                    <Row className="mt-2">
                      <Col style={{ marginBottom: "-1.5rem" }}>
                        {index === 1 ? (
                          <TextInput
                            keyField={`options[1].text`}
                            formik={formik}
                            value={"Phone"}
                            isError={null}
                            disabled={true}
                            required={false}
                            propsOptionData={0}
                          />
                        ) : null}
                      </Col>
                      <Col />
                      <Col />
                    </Row>
                  </div>
                ))}
              </Col>
            ) : (
              <Col>
                {formik.values?.options?.map((row, index) => {
                  const disableRemove = formik.values?.options?.length < 2;
                  const isChannelQuestion =
                    questionTagValue === "CHANNEL" &&
                    formik.values.answerType === "radio" &&
                    selectedCategoryType === "getcare-waitingroom";

                  return (
                    <div key={row.id}>
                      <Row className={index === 0 ? "" : "mt-2"}>
                        <Col style={{ marginBottom: "-1.5rem" }}>
                          {isChannelQuestion ? (
                            channelDataMap
                          ) : (
                            <TextInput
                              keyField={`options[${index}].text`}
                              label={index === 0 ? "Answers" : false}
                              formik={formik}
                              placeholder={"Write your answer"}
                              isError={formik?.touched?.options?.[index]?.text && formik?.errors?.options?.[index]?.text}
                              disabled={isReadOnly}
                            />
                          )}
                        </Col>
                        <Col
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "1rem",
                            marginBottom: "-1.5rem",
                          }}
                        >
                          {!isReadOnly ? (
                            <>
                              <div style={{ ...iconStyle, cursor: disableRemove ? "auto" : "pointer" }}>
                                <Remove
                                  style={{ width: "inherit", height: "inherit", color: "rgba(0, 93, 168, 1)", opacity: disableRemove ? "0.3" : "1" }}
                                  onClick={() => !disableRemove && removeRow({ index, formik })}
                                />
                              </div>
                              <div style={iconStyle}>
                                <Add
                                  style={{ width: "inherit", height: "inherit", color: "rgba(0, 93, 168, 1)" }}
                                  onClick={() => addRow({ formik })}
                                />
                              </div>
                            </>
                          ) : null}
                        </Col>
                        <Col />
                      </Row>
                    </div>
                  );
                })}
              </Col>
            )}
          </Row>

          <Row className={(formik.values.answerType === "freeText" || formik.values.answerType === "singleFreeText") ? "" : "mt-4"}>
            <Col md={12}>
              <TextArea keyField={"note"} label={"Note"} formik={formik} placeholder={"Write here..."} required={false} disabled={isReadOnly} />
            </Col>
          </Row>
        </>
      ) : selectedCategoryType !== undefined && selectedCategoryType === "clinical-visit" ? (
        <>
          <Row>
            <Col>
              <div className="field-wrap" style={{ margin: 0 }}>
                <label className="custom-checkbox" style={{ margin: 0, width: "fit-content" }}>
                  Is Mandatory
                  <>
                    <input style={{ width: "auto" }} type="checkbox" checked={formik.values.required} onChange={() => formik.setFieldValue("required", !!!formik?.values?.required)} disabled={isReadOnly} />
                    <span className="checkmark"></span>
                  </>
                </label>
              </div>
            </Col>
          </Row>

          <Row className="align-items-center">
            <Col className="col-md-4">
              <SelectFiled
                keyField={"answerType"}
                label={"Answer type"}
                formik={formik}
                placeholder={"Answer type"}
                options={answerTypeOptions}
                disabled={isReadOnly}
                onChange={(e) => {
                  formik.handleChange(e);
                  handleChangeAnsType();
                }}
              />
            </Col>
            <Col>
              {isVideoVisit && formik.values.answerType === "radio" ? (
                <>
                  <img src={DeleteIcon} alt="Delete" onClick={(ev) => setAnchorEl(open ? null : ev.currentTarget)} style={{ cursor: "pointer" }} />
                  {!isReadOnly && (
                    <Menu
                      id="question-tag-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      anchorOrigin={{ vertical: "top", horizontal: "left" }}
                      transformOrigin={{ vertical: "top", horizontal: "left" }}
                    >
                      {selectedCategoryType === "clinical-visit" && formik.values.answerType === "radio"
                        ? questionTagRadioOptionsVideoVisit.map((o) => <MenuItem key={o.value} onClick={() => handleClose(o.value)}>{o.name}</MenuItem>)
                        : null}
                    </Menu>
                  )}
                </>
              ) : null}

              {(formik.values.answerType === "freeText" || formik.values.answerType === "singleFreeText" || formik.values.answerType === "radio" || formik.values.answerType === "dropDown") &&
                questionTagValue !== undefined &&
                stackName !== undefined ? (
                <Stack direction="row" spacing={1} className="d-inline-flex ms-1 ms-sm-4">
                  <Chip label={stackName} onDelete={handleDeleteChip} color={isReadOnly ? "default" : "primary"} disabled={isReadOnly} />
                </Stack>
              ) : null}
            </Col>
          </Row>

          <Row>
            {(formik.values.answerType === "freeText" || formik.values.answerType === "singleFreeText") ? null : (
              <Col>
                {formik.values?.options?.map((row, index) => {
                  const disableRemove = formik.values?.options?.length < 2;
                  return (
                    <div key={row.id}>
                      <Row className={index === 0 ? "" : "mt-2"}>
                        <Col style={{ marginBottom: "-1.5rem" }}>
                          <TextInput
                            keyField={`options[${index}].text`}
                            label={index === 0 ? "Answers" : false}
                            formik={formik}
                            placeholder={"Write your answer"}
                            isError={formik?.touched?.options?.[index]?.text && formik?.errors?.options?.[index]?.text}
                            disabled={isReadOnly}
                          />
                        </Col>
                        <Col
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "1rem",
                            marginBottom: "-1.5rem",
                          }}
                        >
                          {!isReadOnly ? (
                            <>
                              <div style={{ ...iconStyle, cursor: disableRemove ? "auto" : "pointer" }}>
                                <Remove
                                  style={{ width: "inherit", height: "inherit", color: "rgba(0, 93, 168, 1)", opacity: disableRemove ? "0.3" : "1" }}
                                  onClick={() => !disableRemove && removeRow({ index, formik })}
                                />
                              </div>
                              <div style={iconStyle}>
                                <Add
                                  style={{ width: "inherit", height: "inherit", color: "rgba(0, 93, 168, 1)" }}
                                  onClick={() => addRow({ formik })}
                                />
                              </div>
                            </>
                          ) : null}
                        </Col>
                        <Col />
                      </Row>
                    </div>
                  );
                })}
              </Col>
            )}
          </Row>

          <Row className={(formik.values.answerType === "freeText" || formik.values.answerType === "singleFreeText") ? "" : "mt-4"}>
            <Col md={12}>
              <TextArea keyField={"note"} label={"Note"} formik={formik} placeholder={"Write here..."} required={false} disabled={isReadOnly} />
            </Col>
          </Row>
        </>
      ) : null}

      {!isReadOnly && isCreate ? (
        <div className="btn-wrap" style={{ display: "flex" }}>
          <Button variant="secondary" title="Cancel" onClick={handleShow}>
            Cancel
          </Button>
          <Button type="submit" isLoading={btnLoading}>
            {isCreate ? "Create" : "Update"}
          </Button>
        </div>
      ) : null}

      {((isReadOnly && !isCreate) || (!isReadOnly && !isCreate)) && <hr />}

      <Row>
        {((isReadOnly && !isCreate) || (!isReadOnly && !isCreate)) && (
          <Col>
            <div>
              <h6>Date Created : {ViewDate(formik?.values?.createdAt)}</h6>
              <h6>Date Last Updated : {ViewDate(formik?.values?.updatedAt)}</h6>
            </div>
          </Col>
        )}

        {!isReadOnly && !isCreate ? (
          <Col>
            <div>
              <Row>
                <Col sm={12} md={12} lg={4} xl={4} className="text-center">
                  <Button variant="secondary" title="Cancel" onClick={handleShow} style={{ width: "100%", marginBottom: "10px", padding: "5px 10px" }}>
                    Cancel
                  </Button>
                </Col>
                <Col sm={12} md={12} lg={4} xl={4} className="text-center">
                  <Button type="submit" isLoading={btnLoading} style={{ width: "100%", marginBottom: "10px", padding: "5px 10px" }}>
                    Update
                  </Button>
                </Col>
                <Col sm={12} md={12} lg={4} xl={4} className="text-center">
                  <Button variant="secondary" title="Deactivate" onClick={() => handleDelete(formik?.values?.id, formik?.values?.question)} style={{ width: "100%", marginBottom: "10px", padding: "5px 10px" }}>
                    Deactivate
                  </Button>
                </Col>
              </Row>
            </div>
          </Col>
        ) : null}
      </Row>
    </form>
  );
}
